import { useQuery } from '@tanstack/react-query';
import { checkWishlistItem } from '../../api/apiStorefront';
import { useAuthContext } from '../../auth/useAuthContext';

export const useCheckWishlistItem = (productId) => {
  const { isAuthenticated } = useAuthContext();

  return useQuery({
    queryKey: ['wishlist-item', 'home', productId],
    queryFn: async () => {
      const response = await checkWishlistItem(productId);
      return response?.data?.data?.in_wishlist || false;
    },
    enabled: isAuthenticated && !!productId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    retry: 1,
  });
};
